import { render, staticRenderFns } from "./submissions.page.vue?vue&type=template&id=4c47d7a3&scoped=true&"
import script from "./submissions.page.vue?vue&type=script&lang=js&"
export * from "./submissions.page.vue?vue&type=script&lang=js&"
import style0 from "./submissions.page.vue?vue&type=style&index=0&id=4c47d7a3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c47d7a3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VCardText,VDialog,VIcon})
